// extracted by mini-css-extract-plugin
export default {"spacer":"spacer__spacer___3zBzM"};